import { Component, OnInit } from '@angular/core';
import { AuthService } from './services/auth.service';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SubscriptionBasedComponent } from './subscription-helpers/subscription-based.component';
import { Event, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { User } from './model/user';
import UserHelper from './helpers/user-helper';
import { ScrollTopService } from './services/scroll-top.service';
import { LightboxConfig } from 'ngx-lightbox';
import { take } from 'rxjs/operators';
import * as globals from '../globals/globals';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends SubscriptionBasedComponent implements OnInit {
  route: string;

  //navbar in case of regular and special cases are handled differently, so I can't encapulate the entire logic in one variable
  showRegularNavbar: boolean;
  specialNavbarType: SpecialNavbarType;
  userHasAccessToNewPortal: boolean;

  readonly ATELIER_NAVBAR = SpecialNavbarType.ATELIER;
  readonly PLACER_NAVBAR = SpecialNavbarType.PLACER;

  constructor(
    public authService: AuthService,
    private iconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private router: Router,
    private scrollTopService: ScrollTopService,
    private _lightBoxConfig: LightboxConfig
  ) {
    super();
    this.iconRegistry.addSvgIconSet(
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        '../assets/icons/iconset.svg'
      )
    );
  }

  ngOnInit() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        const inpressURIFromLoginLink = new URL(
          document.location.href
        ).searchParams.get('inpressURI');
        console.log('inpressURIFromLoginLink', inpressURIFromLoginLink);
        if (
          !this.authService.isAuthenticated() &&
          (!this.authService.isAuthRoute(event.url) || inpressURIFromLoginLink)
        ) {
          const referer = document.referrer ? new URL(document.referrer) : null;

          console.log('referer', referer);

          const isFromVePortal = referer?.host?.includes('erpve.be') ?? false;
          console.log('isFromVePortal', isFromVePortal);

          if (inpressURIFromLoginLink) {
            console.log(
              'setting inpressURI from login link',
              inpressURIFromLoginLink
            );
            sessionStorage.setItem('inpressURI', inpressURIFromLoginLink);
          } else if (isFromVePortal) {
            console.log('setting inpressURI', document.location.href);
            sessionStorage.setItem('inpressURI', document.location.href);
          } else {
            console.log('removeItem inpressURI');

            sessionStorage.removeItem('inpressURI');
          }
        }
      }
      if (event instanceof NavigationEnd) {
        this.route = event.url;
        console.log('on navigation end', this.route);
        if (this.route != null) {
          if (
            this.route.includes('/installateur') ||
            this.route.includes('/ip-installateur')
          ) {
            this.specialNavbarType = SpecialNavbarType.PLACER;
          } else if (this.route.includes('/atelier')) {
            this.specialNavbarType = SpecialNavbarType.ATELIER;
          } else {
            this.specialNavbarType = null;
          }
        } else {
          this.specialNavbarType = null;
        }
        console.info('Authenticated: ' + this.authService.isAuthenticated());
        if (!this.authService.isAuthenticated()) {
          return this.authService.loginWithShortLivedToken().then((res) => {
            if (res === true) {
              this.router.navigateByUrl(this.route);
            } else {
              console.error('Not authenticated!');
              if (!this.authService.isAuthRoute(this.route)) {
                this.router.navigateByUrl('/login');
              }
            }
          });
        } else {
          this.authService
            .getAuthenticatedUserSubscribable()
            .pipe(take(1))
            .toPromise()
            .then(async (user: User) => {
              if (user == null) {
                const currentUserRequest = await this.authService
                  .getCurrentUser()
                  .toPromise();
                user = currentUserRequest.body;
                this.userHasAccessToNewPortal = user.hasNewPortalAccess;
              } else {
                this.userHasAccessToNewPortal = user.hasNewPortalAccess;
              }

              if (this.route == '/login' || this.route == '/') {
                if (UserHelper.isIPPlacer(user)) {
                  this.router.navigateByUrl('/ip-installateur');
                } else if (UserHelper.isPlacer(user)) {
                  this.router.navigateByUrl('/installateur');
                } else if (UserHelper.isAtelier(user)) {
                  this.router.navigateByUrl('/atelier');
                } else if (UserHelper.isAdmin(user)) {
                  this.router.navigateByUrl('/projecten');
                } else if (UserHelper.isClient(user)) {
                  if (user.hasNewPortalAccess) {
                    this.goToNewPortal();
                  } else {
                    this.router.navigateByUrl('/client-corner/lopende');
                  }
                } else {
                  this.router.navigateByUrl('/no-access');
                }
              }
            });
        }
      }
    });
    this.addSubscription(
      this.authService.getAuthenticatedUserSubscribable(),
      (user: User) => {
        this.showRegularNavbar =
          user != null &&
          UserHelper.hasRole(user, 'ROLE_ADMIN', 'ROLE_PORTAL_USER');
        this.userHasAccessToNewPortal = user != null && user.hasNewPortalAccess;
      }
    );
    this.addSubscription(
      this.scrollTopService.getScrollTopSubscribable(),
      (value: number) => {
        this._lightBoxConfig.positionFromTop = (value == null ? 0 : value) + 20;
        // @ts-ignore
        lightbox.option({
          positionFromTop: (value == null ? 0 : value) + 50,
          fitImagesInViewport: value == null,
          maxWidth: value == null ? null : 1196,
          maxHeight: value == null ? null : 800,
        });
      }
    );
  }

  goToNewPortal() {
    window.location.href = globals.newPortalUrl;
  }
}

enum SpecialNavbarType {
  PLACER,
  ATELIER,
}
